import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import AddMonitorBar from './AddMonitorBar';
import WatchlistStarterCards from './WatchlistStarterCards';
import { TRANSLATION_KEY } from '../constants';
import css from './WatchlistEmptyState.css';

const WatchlistEmptyState = ({
    onSubmit,
    scheduleCron,
    onScheduleClick,
    suggestion = null,
    onPickSuggestion,
    submitting = false,
    error = null,
}) => (
    <div className={css.emptyState}>
        <div className={css.title}>
            <Translate id={`${TRANSLATION_KEY}.EMPTY_STATE.TITLE`} />
        </div>
        <div className={css.subtitle}>
            <Translate id={`${TRANSLATION_KEY}.EMPTY_STATE.SUBTITLE`} />
        </div>
        <AddMonitorBar
            suggestion={suggestion}
            onSubmit={onSubmit}
            scheduleCron={scheduleCron}
            onScheduleClick={onScheduleClick}
            submitting={submitting}
            error={error}
            isEmptyVariant
        />
        <div className={css.suggestionsTitle}>
            <Translate id={`${TRANSLATION_KEY}.EMPTY_STATE.SUGGESTIONS_TITLE`} />
        </div>
        <WatchlistStarterCards onPick={onPickSuggestion} />
    </div>
);

WatchlistEmptyState.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    scheduleCron: PropTypes.string.isRequired,
    onScheduleClick: PropTypes.func.isRequired,
    suggestion: PropTypes.shape({
        text: PropTypes.string.isRequired,
        seq: PropTypes.number.isRequired,
    }),
    onPickSuggestion: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    error: PropTypes.string,
};

export default WatchlistEmptyState;
